<template>
  <div
    style="
      background: #f8fafc;
      min-height: 100vh;
      font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    "
  >
    <!-- Main Content -->
    <div id="main" style="margin-top: 0px; padding: 0px">
      <!-- Hero Section -->
      <div
        class="hero-section"
        style="
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          color: white;
          padding: 60px 0;
          margin: -20px -20px 40px -20px;
          position: relative;
          overflow: hidden;
        "
      >
        <div
          style="
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background:
              radial-gradient(
                circle at 20% 50%,
                rgba(255, 255, 255, 0.1) 1px,
                transparent 1px
              ),
              radial-gradient(
                circle at 80% 50%,
                rgba(255, 255, 255, 0.1) 1px,
                transparent 1px
              );
            background-size: 50px 50px;
            opacity: 0.3;
          "
        ></div>
        <div
          class="container text-center"
          style="position: relative; z-index: 2"
        >
          <h1
            style="
              font-size: 3rem;
              font-weight: 800;
              margin-bottom: 16px;
              letter-spacing: -1px;
              text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
            "
          >
            Welcome to Geek Cafe
          </h1>
          <p
            style="
              font-size: 1.2rem;
              opacity: 0.95;
              max-width: 600px;
              margin: 0 auto 30px;
              line-height: 1.6;
            "
          >
            Your hub for development tutorials, tools, and technical insights
          </p>
          <div
            style="
              display: inline-flex;
              gap: 16px;
              flex-wrap: wrap;
              justify-content: center;
            "
          >
            <!-- <NuxtLink to="/blog" style="background: rgba(255,255,255,0.2); border: 2px solid rgba(255,255,255,0.3); color: white; padding: 12px 24px; border-radius: 8px; font-weight: 600; backdrop-filter: blur(10px); transition: all 0.3s; cursor: pointer; text-decoration: none; display: inline-block;">Explore Blog</NuxtLink> -->
            <NuxtLink
              to="/services"
              style="
                background: rgba(255, 255, 255, 0.9);
                border: 2px solid transparent;
                color: #667eea;
                padding: 12px 24px;
                border-radius: 8px;
                font-weight: 600;
                transition: all 0.3s;
                cursor: pointer;
                text-decoration: none;
                display: inline-block;
              "
              >View Services</NuxtLink
            >
          </div>
        </div>
      </div>

      <!-- Services Section -->
      <div
        id="services"
        style="
          padding: 80px 0;
          background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
        "
      >
        <div class="container">
          <div class="text-center mb-5">
            <h2
              style="
                font-size: 3rem;
                font-weight: 700;
                color: #1a202c;
                margin-bottom: 16px;
              "
            >
              Our Services
            </h2>
            <p
              style="
                font-size: 1.2rem;
                color: #4a5568;
                max-width: 600px;
                margin: 0 auto;
              "
            >
              Transform your business with our comprehensive development and
              cloud architecture solutions
            </p>
          </div>

          <div class="row">
            <PlatformMaintenance />
            <DevelopmentServices />
            <AWSCloudArchitecture />
            <AWSDevops />
            <AwsMigration />
            <ApiDevelopment />
            <ApplicationDevelopment />
            <DatabaseDesign />
          </div>
        </div>
      </div>

      <OurMethodology />

      <!-- Featured Blog Posts -->
      <div style="padding: 80px 0;">
        <div class="container">
          <div class="text-center mb-5">
            <h2 style="font-size: 2.5rem; font-weight: 700; color: #1a202c; margin-bottom: 16px;">Latest Blog Posts</h2>
            <p style="font-size: 1.1rem; color: #4a5568;">Stay updated with the latest development tutorials and insights</p>
          </div>
          
          <div class="row">
            <div v-for="post in featuredPosts" :key="post._path" class="col-md-6 mb-4">
              <BlogCard :post="post" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- End of main content -->
  </div>
</template>

<script setup>
import PlatformMaintenance from "~/components/services/PlatformMaintenance.vue";
import DevelopmentServices from "~/components/services/DevelopmentServices.vue";
import AWSCloudArchitecture from "~/components/services/AWSCloudArchitecture.vue";
import ApiDevelopment from "~/components/services/ApiDevelopment.vue";
import ApplicationDevelopment from "~/components/services/ApplicationDevelopment.vue";
import AwsMigration from "~/components/services/AwsMigration.vue";
import AWSDevops from "~/components/services/AWSDevops.vue";
import DatabaseDesign from "~/components/services/DatabaseDesign.vue";
import OurMethodology from "~/components/OurMethodology.vue";
import BlogCard from "~/components/blog/BlogCard.vue";

const { data: posts } = await useAsyncData('posts', () => $fetch('/api/posts'))

const featuredPosts = computed(() => {
  if (!posts.value) return []
  return posts.value.slice(0, 4)
})

// Homepage component
definePageMeta({
  layout: "default",
  title: "Welcome",
});
</script>

<style scoped>
/* Any additional styling specific to the homepage can go here */

/* Responsive hero section margins */
@media (max-width: 576px) {
  .hero-section {
    margin: -8px -8px 20px -8px !important;
    padding: 40px 0 !important;
  }
}

@media (min-width: 577px) and (max-width: 768px) {
  .hero-section {
    margin: -12px -12px 30px -12px !important;
    padding: 50px 0 !important;
  }
}

@media (min-width: 769px) and (max-width: 992px) {
  .hero-section {
    margin: -16px -16px 35px -16px !important;
  }
}

/* Mobile typography adjustments */
@media (max-width: 576px) {
  .hero-section h1 {
    font-size: 2rem !important;
    margin-bottom: 12px !important;
  }
  
  .hero-section p {
    font-size: 1rem !important;
    margin-bottom: 20px !important;
  }
  
  .hero-section .container {
    padding: 0 16px !important;
  }
}

@media (min-width: 577px) and (max-width: 768px) {
  .hero-section h1 {
    font-size: 2.5rem !important;
  }
  
  .hero-section p {
    font-size: 1.1rem !important;
  }
}
</style>
